import React, { useState } from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import RequestOrderInvoice from '../controlModal/RequestOrderInvoice';
import UnsubscribeProduct from '../controlModal/UnsubscribeProduct';
import { dateConverter } from '../../../../helper/Helper';

const OrderDetailsModal = (props) => {
    const [orderControlModal, setOrderControlModal] = useState({ toggle: false, activity: null });

    const subscriptionActivityMessage = {
        failed: "Failed to subscribe", // subscription failed to get applied
        awaiting: "Awaiting approval", // awaiting for process to end => hide premium content
        trialing: "Trial is applied", // active and allow premium content
        active: "Subscription is active", // active susbcription => show premium content
        inactive: "Subscription is cancelled", // inactive subscription => hide premium content
        requiresAuth: "Requires authentication", // hide premium content
        deleted: "Deleted subscription", // hide all premium content
        renewed: "Subscription is renewed", // mark as renewed and hide premium content with such status
    }

    const subTitleStyle = {
        fontSize: '14px',
        fontWeight: 'bold',
    };
    const titleStyle = {
        fontSize: '16px',
        fontWeight: 'bold',
    };

    const {
        orderDetails, userData, companyData,
        modalStyles, modalWidth, modalTitleStyle, modalInfoTextStyle,
    } = props;
    // console.log(orderDetails);
    if (orderDetails) {
        const { orderId, subscriptionActivity } = orderDetails;
        let boughtOrderId = 'boughtSubscription' in companyData ? companyData.boughtSubscription.orderId : null;
        const subscriptionBoughtActive = boughtOrderId === orderId ? companyData.boughtSubscription.applied ? <a href="#!" onClick={() => { setOrderControlModal({ toggle: true, activity: subscriptionActivity }) }} className="btn btn-sm btn-danger">Unsubscribe</a> : <a href="#!" onClick={() => { setOrderControlModal({ toggle: true, activity: subscriptionActivity }) }} className="btn btn-sm btn-danger">Unsubscribe</a> : <React.Fragment />

        const requestInvoice = <a href="#!" onClick={() => { setOrderControlModal({ toggle: true, activity: null }) }} className="btn btn-sm btn-dark">Get invoice</a>
        const relevantActionButton = subscriptionActivity === 'active' || subscriptionActivity === 'trialing' ? <React.Fragment>{requestInvoice}<br /><br />{subscriptionBoughtActive}</React.Fragment> : subscriptionActivity !== 'requiresAuth' ? requestInvoice : <React.Fragment />

        // console.log(subscriptionActivity)
        const relevantModalBody = orderControlModal ? orderControlModal.activity === 'active' || orderControlModal.activity === 'trialing' ? <UnsubscribeProduct orderId={orderId} /> : orderControlModal.activity !== 'requiresAuth' ? <RequestOrderInvoice orderId={orderId} /> : <React.Fragment /> : <React.Fragment />


        return (
            <React.Fragment>
                <div className="text-left">
                    <h5 style={titleStyle}>{orderDetails.itemName}</h5>
                    <div className="pt-3">
                        <hr />
                        <h5 style={subTitleStyle}>Important information</h5>
                        <hr />
                        <p><b>Order Id:</b> {orderDetails.orderId}</p>
                        <p><b>Active from <u>{dateConverter((orderDetails.tierId === "tier_free" ? orderDetails.stripeSubscriptionObject.trial_start : orderDetails.periodStart) * 1000).parsedDate}</u> to <u>{dateConverter((orderDetails.tierId === "tier_free" ? orderDetails.stripeSubscriptionObject.trial_end : orderDetails.periodEnd) * 1000).parsedDate}</u></b></p>
                        <hr />
                        {/* <p><b>Invoice details:</b> {orderDetails.invoiceId}</p> */}
                        <p><b>Subscription status:</b> {subscriptionActivityMessage[orderDetails.subscriptionActivity]}</p>
                        <p><b>Purchased via:</b> {orderDetails.purchasedVia === "stripe" ? "Web" : "Mobile app"}</p>
                        <p><b>Last modified on:</b> {dateConverter(orderDetails.timestamp).parsedDate}</p>
                    </div>
                    {orderDetails.purchasedVia === "stripe" ?
                        <div className="pt-3">
                            <hr />
                            <h5 style={subTitleStyle}>Take action</h5>
                            <hr />
                            {relevantActionButton}
                        </div> : <React.Fragment />
                    }
                </div>

                {/* CONTROL MODAL */}
                <ReactModal
                    style={modalStyles}
                    isOpen={orderControlModal.toggle}
                    onRequestClose={() => { setOrderControlModal({ toggle: false }) }}
                    contentLabel="See order controls"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { setOrderControlModal({ toggle: false }) }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="dynamicModalContainer">
                        <div className="dynamicModalSm">
                            <div className="px-3">
                                <p style={modalTitleStyle}>Order settings</p>
                                <blockquote className="blockquote">
                                    <h3><span></span><span style={{ color: "gray" }}>{orderDetails.itemName}</span></h3>
                                    <footer className="blockquote-footer">{orderDetails.tierId === "tier_free" ? `Will expire on ${dateConverter(orderDetails.stripeSubscriptionObject.trial_end * 1000).parsedDate}` : `Subscription renews every ${orderDetails.subscriptionPeriod}`}</footer>
                                </blockquote>
                                {/* <br /> */}
                                {relevantModalBody}
                                <br />
                            </div>
                        </div>
                    </div>
                </ReactModal>
            </React.Fragment>
        );
    } else {
        return (
            <div className="text-left">
                <h5 style={titleStyle}>No details found</h5>
            </div>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,

        formLabelStyle: state.appControl.formLabelStyle,
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,

        userData: state.firebase.profile,
        userId: state.firebase.auth.uid,
        companyData: state.firestore.data.Company,
    }
}

export default connect(mapStateToProps)(OrderDetailsModal);